import { useOverlayState } from "@heroui/react";
import { useTranslation } from "react-i18next";
import { MicrosoftIcon } from "@/src/common/assets/icons";
import { Button, Modal } from "@/src/common/components/ui";

interface MicrosoftAccountModalProps {
	isOpen: boolean;
	onClose: () => void;
	onMicrosoftSignIn: () => void;
}

export function MicrosoftAccountModal({ isOpen, onClose, onMicrosoftSignIn }: MicrosoftAccountModalProps) {
	const { t } = useTranslation("auth");

	const state = useOverlayState({
		isOpen,
		onOpenChange: (open) => {
			if (!open) onClose();
		},
	});

	const handleMicrosoftSignIn = () => {
		onClose();
		onMicrosoftSignIn();
	};

	return (
		<Modal state={state}>
			<Modal.Backdrop>
				<Modal.Container>
					<Modal.Dialog>
						<Modal.Header>
							<Modal.Heading className="text-xl font-semibold">{t("microsoft_account_modal_title")}</Modal.Heading>
						</Modal.Header>
						<Modal.Body className="flex flex-col items-center gap-4 pb-6">
							<MicrosoftIcon width={48} height={48} />
							<p className="text-foreground/50 text-center">{t("microsoft_account_modal_description")}</p>
							<Button variant="primary" className="w-full" onPress={handleMicrosoftSignIn}>
								<MicrosoftIcon width={18} height={18} />
								{t("sign_in_microsoft")}
							</Button>
						</Modal.Body>
					</Modal.Dialog>
				</Modal.Container>
			</Modal.Backdrop>
		</Modal>
	);
}
